import { MimeTypes } from './enums';

export const PREVIEW_FILE_TYPES = [
  MimeTypes.pdf,
  MimeTypes.jpeg,
  MimeTypes.jpg,
  MimeTypes.png,
  MimeTypes.docx
];

export const FORCED_SHOW_THUMBNAILS_FILE_TYPES = [MimeTypes.docx];
